import { instance } from "../API/Axios";
 
export const GetRoleVsMenusApi = async () =>{
    try{
        const response = await instance.get("getRoleVsMenus");
        return response.data;
    }
   catch(ex){
   throw ("Exception Occured "+ex)
   }
}

export const GetSubscribersApi = async () =>{
    try{
        const response = await instance.get("getSubscribers");
        return response.data;
    }
   catch(ex){
   throw ("Exception Occured "+ex)
   }
}

export const CreateUserApi = async (req) =>{
    try{
        const response = await instance.post("CreateUser",req);
        return response.data;
    }catch(ex){
        throw(ex)
    }
}